<template>
  <v-app style="background-color: #f8f9fb">
    <v-dialog v-model="loading" persistent max-width="320">
      <v-card class="pa-6 text-center">
        <v-progress-circular
          indeterminate
          color="primary"
          size="52"
          width="4"
        />
        <div class="mt-4 text-subtitle-1 font-weight-medium">
          Carregando relatório...
        </div>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="5000">
      {{ snackbar.message }}
      <template #action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">Fechar</v-btn>
      </template>
    </v-snackbar>

    <v-container
      id="relatorio-funerario"
      fluid
      tag="section"
      class="relatorio-funerario"
    >
      <base-material-card
        icon="mdi-clipboard-pulse-outline"
        title="Relatório Funerário"
        color="primary"
        class="px-5 py-4"
        style="margin-top: 20px !important; padding-top: 10px !important"
      >
        <div class="text-subtitle-2 grey--text text--darken-1 mb-4">
          Indicadores operacionais dos serviços funerários
        </div>

        <v-card class="pa-4 mb-5 filtro-card" elevation="0">
          <v-row dense align="end">
            <v-col cols="12" sm="5" md="3" lg="3">
              <span>Filtrar por</span>
              <v-select
                v-model="filtros.tipoData"
                :items="['Solicitação do Serviço']"
                dense
                solo-inverted
                hide-details
                label="Filtrar"
              />
            </v-col>

            <v-col cols="12" sm="5" md="3" lg="2">
              <span>Data inicial</span>
              <v-text-field
                v-model="filtros.dataInicio"
                type="date"
                dense
                solo-inverted
                hide-details
                @input="periodoRapido = null"
              />
            </v-col>

            <v-col cols="12" sm="5" md="3" lg="2">
              <span>Data final</span>
              <v-text-field
                v-model="filtros.dataFim"
                type="date"
                dense
                solo-inverted
                hide-details
                @input="periodoRapido = null"
              />
            </v-col>

            <v-col cols="12" sm="2" md="3" lg="2" class="d-flex">
              <v-btn
                color="primary"
                class="text-capitalize font-weight-bold"
                height="38"
                :loading="loading"
                @click="carregarRelatorio"
              >
                <v-icon left>mdi-refresh</v-icon>
                Atualizar
              </v-btn>
            </v-col>
          </v-row>

          <div class="periodo-chips mt-3">
            <v-chip
              v-for="periodo in periodosRapidos"
              :key="periodo.valor"
              small
              :outlined="periodoRapido !== periodo.valor"
              class="mr-2 mb-2"
              :color="periodoRapido === periodo.valor ? 'primary' : undefined"
              :text-color="
                periodoRapido === periodo.valor ? 'white' : undefined
              "
              @click="aplicarPeriodoRapido(periodo.valor)"
            >
              <v-icon left small>{{ periodo.icone }}</v-icon>
              {{ periodo.texto }}
            </v-chip>
          </div>
        </v-card>

        <v-alert
          v-if="semDados && !loading"
          type="info"
          text
          dense
          class="mb-5"
        >
          Nenhum serviço encontrado para o período selecionado.
        </v-alert>

        <v-row class="mb-4">
          <v-col
            v-for="card in cardsPrincipais"
            :key="card.titulo"
            cols="12"
            sm="6"
            md="4"
            lg="4"
            xl="4"
          >
            <div class="indicador-card-wrapper">
              <base-material-stats-card
                :color="card.cor"
                elevation="1"
                :icon="card.icone"
                :title="card.titulo"
                :value="card.valor"
                :valuex="false"
                :sub-text="card.subtexto"
              />
              <div class="indicador-info-icon">
                <v-tooltip bottom max-width="280">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      color="primary"
                      size="20"
                      style="opacity: 0.7"
                    >
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <span>{{ card.descricao }}</span>
                </v-tooltip>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-tabs v-model="tabAtiva" class="mb-5" color="primary">
          <v-tab>
            <v-icon left>mdi-clipboard-list-outline</v-icon>
            Procedimentos
          </v-tab>
          <v-tab>
            <v-icon left>mdi-cash-multiple</v-icon>
            Comissão
          </v-tab>
         <!--  <v-tab>
            <v-icon left>mdi-account-tie-outline</v-icon>
            Agentes funerários
          </v-tab> -->
        </v-tabs>

        <v-tabs-items v-model="tabAtiva">
          <v-tab-item>
            <v-row dense class="mb-5">
              <v-col cols="12">
                <v-card class="painel-card tabela-procedimentos" elevation="0">
                  <div class="d-flex align-center justify-space-between mb-2">
                    <div>
                      <div class="text-subtitle-2 font-weight-bold">
                        Resumo de procedimentos não realizados
                      </div>
                      <div class="text-caption grey--text text--darken-1">
                        Clique em uma linha para filtrar os serviços.
                      </div>
                    </div>
                    <v-icon color="grey darken-1">mdi-format-list-checks</v-icon>
                  </div>
                  <v-simple-table dense class="resumo-table">
                    <thead>
                      <tr>
                        <th>Procedimento</th>
                        <th class="text-right">Realizado</th>
                        <th class="text-right">Não realizado</th>
                        <th class="text-right">Percentual</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in procedimentosResumo"
                        :key="item.procedimento"
                        class="pointer procedimento-row"
                        :class="{
                          active: filtroProcedimento === item.procedimento,
                        }"
                        @click="filtrarDetalhes(item.procedimento)"
                      >
                        <td>
                          <div class="d-flex align-center">
                            <span class="procedimento-dot mr-2"></span>
                            <span class="font-weight-medium">{{
                              item.procedimento
                            }}</span>
                          </div>
                        </td>
                        <td class="text-right">
                          {{ numero(totalRealizadoProcedimento(item)) }}
                        </td>
                        <td class="text-right">{{ numero(item.quantidade) }}</td>
                        <td class="text-right">
                          <v-chip x-small outlined color="primary">
                            {{ percentualFormatado(item.percentual) }}
                          </v-chip>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-card>
              </v-col>
            </v-row>

            <v-card class="pa-4 mb-5 painel-card servicos-card" elevation="0">
          <div class="text-h6 font-weight-medium mb-3">Serviços</div>
          <v-divider class="mb-4"></v-divider>

          <div class="servicos-toolbar mb-3">
            <div class="servicos-busca-row">
              <v-text-field
                v-model="filtroBusca"
                class="servicos-busca"
                prepend-inner-icon="mdi-magnify"
                placeholder="Buscar por cliente, falecido ou ticket"
                dense
                outlined
                hide-details
                clearable
              />
            </div>
            <div class="procedimento-chips">
              <v-chip
                small
                class="mr-2 mb-2"
                :outlined="filtroProcedimento !== 'Todos'"
                :color="filtroProcedimento === 'Todos' ? 'primary' : undefined"
                :text-color="
                  filtroProcedimento === 'Todos' ? 'white' : undefined
                "
                @click="filtroProcedimento = 'Todos'"
              >
                Todos
              </v-chip>
              <v-chip
                v-for="item in procedimentosResumo"
                :key="item.procedimento"
                small
                class="mr-2 mb-2"
                :outlined="filtroProcedimento !== item.procedimento"
                :color="
                  filtroProcedimento === item.procedimento
                    ? 'primary'
                    : undefined
                "
                :text-color="
                  filtroProcedimento === item.procedimento ? 'white' : undefined
                "
                @click="filtroProcedimento = item.procedimento"
              >
                {{ item.procedimento }}: {{ item.quantidade || 0 }}
              </v-chip>
            </div>
          </div>
          <div class="text-caption grey--text text--darken-1 mb-3">
            {{ numero(servicosFiltrados.length) }} de
            {{ numero(servicos.length) }} serviço(s)
          </div>

          <v-expansion-panels multiple flat class="servicos-panels">
            <v-expansion-panel
              v-for="servico in servicosPaginados"
              :key="servico.servicoId"
              class="servico-panel"
            >
              <v-expansion-panel-header>
                <div class="servico-header">
                  <div>
                    <div class="servico-id">
                      #{{ servico.idAtendimento || servico.servicoId }}
                    </div>
                    <div class="text-caption grey--text text--darken-1">
                      Serviço
                    </div>
                  </div>
                  <div>
                    <div class="text-caption grey--text text--darken-1 mb-1">
                      Falecido(a)
                    </div>
                    <div class="font-weight-bold text-body-1">
                      {{ servico.falecido || "-" }}
                    </div>
                  </div>
                  <div>
                    <div class="text-caption grey--text text--darken-1 mb-1">
                      Cliente
                    </div>
                    <div class="font-weight-medium">
                      {{ servico.cliente || "Não informado" }}
                    </div>
                  </div>
                  <div>
                    <div class="text-caption grey--text text--darken-1 mb-1">
                      Data
                    </div>
                    <div class="text-body-2">
                      {{ servico.dataServico || "-" }}
                    </div>
                  </div>
                  <v-chip
                    v-if="
                      servico.procedimentosAusentes &&
                      servico.procedimentosAusentes.length
                    "
                    small
                    color="orange lighten-5"
                    text-color="orange darken-3"
                  >
                    {{ servico.procedimentosAusentes.length }} ausente(s)
                  </v-chip>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="servico-content">
                <v-row dense class="info-grid mb-3">
                  <v-col cols="12" md="3">
                    <span>Tipo</span>
                    <strong>{{ servico.tipoServico || "-" }}</strong>
                  </v-col>
                  <v-col cols="12" md="3">
                    <span>Responsável</span>
                    <strong>{{ servico.responsavel || "-" }}</strong>
                  </v-col>
                  <v-col cols="12" md="3">
                    <span>Etapa atual</span>
                    <strong>{{ servico.etapaAtual || "-" }}</strong>
                  </v-col>
                  <v-col cols="12" md="3">
                    <span>Etapas registradas</span>
                    <strong>{{ numero((servico.etapas || []).length) }}</strong>
                  </v-col>
                </v-row>

                <div
                  v-if="
                    servico.procedimentosAusentes &&
                    servico.procedimentosAusentes.length
                  "
                  class="mb-3"
                >
                  <div class="text-caption grey--text text--darken-1 mb-1">
                    Etapas esperadas não realizadas
                  </div>
                  <v-chip
                    v-for="ausente in servico.procedimentosAusentes"
                    :key="`${servico.servicoId}-${ausente}`"
                    small
                    color="orange lighten-4"
                    class="mr-2 mb-2"
                  >
                    {{ ausente }}
                  </v-chip>
                </div>

                <v-expansion-panels multiple flat class="etapas-panels">
                  <v-expansion-panel
                    v-for="etapa in servico.etapas"
                    :key="etapa.registroEtapaId"
                    class="etapa-panel"
                  >
                    <v-expansion-panel-header>
                      <div class="etapa-header">
                        <strong>{{
                          etapa.etapaNome || "Etapa sem nome"
                        }}</strong>
                        <div class="sla-resumo">
                          <div class="sla-item">
                            <span>Esperado</span>
                            <strong>{{ formatarSlaEsperado(etapa) }}</strong>
                          </div>
                          <div class="sla-item">
                            <span>Realizado</span>
                            <strong>{{ formatarSlaRealizado(etapa) }}</strong>
                          </div>
                        </div>
                        <v-chip
                          v-if="
                            etapa.dentroSla !== null &&
                            etapa.dentroSla !== undefined
                          "
                          x-small
                          :color="
                            etapa.dentroSla
                              ? 'green lighten-5'
                              : 'red lighten-5'
                          "
                          :text-color="
                            etapa.dentroSla ? 'green darken-3' : 'red darken-3'
                          "
                        >
                          {{
                            etapa.dentroSla ? "Dentro do SLA" : "Fora do SLA"
                          }}
                        </v-chip>
                        <v-chip
                          v-if="temOcorrencia(etapa)"
                          x-small
                          color="amber lighten-5"
                          text-color="amber darken-4"
                        >
                          Ocorrência
                        </v-chip>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row dense class="mb-2">
                        <v-col cols="12" sm="4"
                          ><strong>Início:</strong>
                          {{ etapa.dtInicio || "-" }}</v-col
                        >
                        <v-col cols="12" sm="4"
                          ><strong>Fim:</strong> {{ etapa.dtFim || "-" }}</v-col
                        >
                        <v-col cols="12" sm="4"
                          ><strong>Colaboradores:</strong>
                          {{ etapa.totalColaboradores || 0 }}</v-col
                        >
                      </v-row>

                      <div
                        v-if="temOcorrencia(etapa)"
                        class="ocorrencia-box mb-3"
                      >
                        <div class="ocorrencia-titulo">
                          <v-icon small color="amber darken-3" class="mr-1"
                            >mdi-alert-circle-outline</v-icon
                          >
                          Ocorrência considerada no SLA
                        </div>
                        <div class="ocorrencia-grid">
                          <div>
                            <span>Duração bruta</span>
                            <strong>{{
                              formatarMinutos(etapa.tempoRealizado)
                            }}</strong>
                          </div>
                          <div>
                            <span>Abatimento</span>
                            <strong>{{
                              formatarMinutos(etapa.tempoOcorrencia)
                            }}</strong>
                          </div>
                          <div>
                            <span>Considerado no SLA</span>
                            <strong>{{ formatarSlaRealizado(etapa) }}</strong>
                          </div>
                        </div>
                        <div
                          v-if="etapa.ocorrenciaJustificativa"
                          class="ocorrencia-texto"
                        >
                          {{ etapa.ocorrenciaJustificativa }}
                        </div>
                      </div>

                      <v-chip
                        v-for="colaborador in etapa.colaboradores"
                        :key="`${etapa.registroEtapaId}-${colaborador.colaboradorId}`"
                        small
                        class="mr-2 mb-2"
                      >
                        {{ colaborador.colaboradorNome }}:
                        {{ colaborador.quantidade }}
                      </v-chip>

                      <v-expansion-panels
                        v-if="etapa.atividades && etapa.atividades.length"
                        multiple
                        flat
                        class="mt-3 atividades-panels"
                      >
                        <v-expansion-panel
                          v-for="atividade in etapa.atividades"
                          :key="atividade.atividadeId"
                          class="atividade-panel"
                        >
                          <v-expansion-panel-header>
                            <div class="atividade-header">
                              <span>{{
                                atividade.atividadeNome ||
                                "Atividade sem descrição"
                              }}</span>
                              <span>{{
                                formatarMinutos(atividade.tempoOcorrencia)
                              }}</span>
                              <span
                                >{{
                                  atividade.totalColaboradores || 0
                                }}
                                colaborador(es)</span
                              >
                            </div>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-row dense class="mb-2">
                              <v-col cols="12" sm="6"
                                ><strong>Início:</strong>
                                {{ atividade.dtInicio || "-" }}</v-col
                              >
                              <v-col cols="12" sm="6"
                                ><strong>Fim:</strong>
                                {{ atividade.dtFim || "-" }}</v-col
                              >
                            </v-row>

                            <v-chip
                              v-for="colaborador in atividade.colaboradores"
                              :key="`${atividade.atividadeId}-${colaborador.colaboradorId}`"
                              small
                              class="mr-2 mb-2"
                            >
                              {{ colaborador.colaboradorNome }}:
                              {{ colaborador.quantidade }}
                            </v-chip>
                            <span
                              v-if="
                                !atividade.colaboradores ||
                                !atividade.colaboradores.length
                              "
                              class="text-caption grey--text"
                            >
                              Sem colaboradores registrados nessa atividade.
                            </span>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <div v-if="servicosFiltrados.length" class="servicos-paginacao mt-4">
            <div class="text-caption grey--text text--darken-1">
              Exibindo {{ numero(primeiroServicoPagina) }}-{{
                numero(ultimoServicoPagina)
              }}
              de {{ numero(servicosFiltrados.length) }}
            </div>
            <div class="d-flex align-center">
              <v-select
                v-model="itensPorPagina"
                :items="[10, 20, 50, 100]"
                dense
                outlined
                hide-details
                class="itens-pagina mr-3"
              />
              <v-pagination
                v-model="paginaServicos"
                :length="totalPaginasServicos"
                :total-visible="7"
                circle
              />
            </div>
          </div>

          <v-alert v-else type="info" text dense class="mt-3 mb-0">
            Nenhum serviço encontrado para os filtros selecionados.
          </v-alert>
        </v-card>
          </v-tab-item>

          <v-tab-item>
            <v-row class="mb-4">
              <v-col
                v-for="card in cardsComissao"
                :key="card.titulo"
                cols="12"
                sm="6"
                md="4"
                lg="4"
                xl="4"
              >
                <div class="indicador-card-wrapper">
                  <base-material-stats-card
                    :color="card.cor"
                    elevation="1"
                    :icon="card.icone"
                    :title="card.titulo"
                    :value="card.valor"
                    :valuex="false"
                    :sub-text="card.subtexto"
                  />
                </div>
              </v-col>
            </v-row>

            <v-row dense class="mb-5">
              <v-col cols="12">
                <v-card class="painel-card tabela-colaboradores" elevation="0">
                  <div class="d-flex align-center justify-space-between mb-2">
                    <div>
                      <div class="text-subtitle-2 font-weight-bold">
                        Comissão por colaborador
                      </div>
                      <div class="text-caption grey--text text--darken-1">
                        Soma das comissões de todas as etapas realizadas no período.
                      </div>
                    </div>
                    <v-icon color="grey darken-1">mdi-cash-multiple</v-icon>
                  </div>

                  <v-text-field
                    v-model="buscaComissao"
                    class="tabela-busca mb-3"
                    prepend-inner-icon="mdi-magnify"
                    placeholder="Buscar por colaborador"
                    dense
                    outlined
                    hide-details
                    clearable
                  />

                  <v-simple-table dense class="resumo-table">
                    <thead>
                      <tr>
                        <th>Colaborador</th>
                        <th class="text-right">Atividades</th>
                        <th class="text-right">Somato</th>
                        <th class="text-right">Comissão (R$)</th>
                        <th class="text-right">Somato (R$)</th>
                        <th class="text-right">Total (R$)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="colaborador in colaboradoresComissaoPaginados"
                        :key="colaborador.colaboradorId"
                        class="colaborador-row"
                      >
                        <td>
                          <div class="d-flex align-center">
                            <v-icon small color="grey darken-1" class="mr-2">
                              mdi-account-outline
                            </v-icon>
                            <span class="font-weight-medium">{{
                              colaborador.colaboradorNome
                            }}</span>
                          </div>
                        </td>
                        <td class="text-right">
                          {{ numero(colaborador.quantidade) }}
                        </td>
                        <td class="text-right">
                          {{ numero(colaborador.quantidadeSomato) }}
                        </td>
                        <td class="text-right font-weight-bold text-success">
                          {{ formatarMoeda(colaborador.valorReceita) }}
                        </td>
                        <td class="text-right font-weight-bold text-primary">
                          {{ formatarMoeda(colaborador.valorSomato) }}
                        </td>
                        <td class="text-right font-weight-bold text-success">
                          {{ formatarMoeda(colaborador.valorTotal) }}
                        </td>
                      </tr>
                      <tr v-if="!colaboradoresResumoFiltrados.length">
                        <td colspan="6" class="text-center text-caption grey--text py-4">
                          Nenhum colaborador encontrado no período
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>

                  <div
                    v-if="colaboradoresResumoFiltrados.length"
                    class="servicos-paginacao mt-4"
                  >
                    <div class="text-caption grey--text text--darken-1">
                      Exibindo {{ numero(primeiroColaboradorComissaoPagina) }}-{{
                        numero(ultimoColaboradorComissaoPagina)
                      }}
                      de {{ numero(colaboradoresResumoFiltrados.length) }}
                    </div>
                    <div class="d-flex align-center">
                      <v-select
                        v-model="itensPorPaginaComissao"
                        :items="[10, 20, 50, 100]"
                        dense
                        outlined
                        hide-details
                        class="itens-pagina mr-3"
                      />
                      <v-pagination
                        v-model="paginaComissao"
                        :length="totalPaginasComissao"
                        :total-visible="7"
                        circle
                      />
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>

          <v-tab-item>
            <v-row dense class="mb-5">
              <v-col cols="12">
                <v-card class="painel-card tabela-agentes" elevation="0">
                  <div class="d-flex align-center justify-space-between mb-2">
                    <div>
                      <div class="text-subtitle-2 font-weight-bold">
                        Agentes funerários ativos
                      </div>
                    </div>
                    <v-btn
                      text
                      small
                      :loading="loadingAgentesFunerarios"
                      @click="carregarAgentesFunerarios"
                    >
                      <v-icon color="grey darken-1">mdi-refresh</v-icon>
                    </v-btn>
                  </div>

                  <v-text-field
                    v-model="buscaAgentesFunerarios"
                    class="agentes-busca mb-3"
                    prepend-inner-icon="mdi-magnify"
                    placeholder="Buscar por nome, empresa ou CPF"
                    dense
                    outlined
                    hide-details
                    clearable
                  />

                  <v-data-table
                    :headers="headersAgentesFunerarios"
                    :items="agentesFunerarios"
                    :search="buscaAgentesFunerarios"
                    :loading="loadingAgentesFunerarios"
                    :items-per-page="10"
                    sort-by="nome"
                    class="agentes-table"
                    dense
                    no-data-text="Nenhum agente funerário ativo encontrado."
                    loading-text="Carregando agentes funerários..."
                  >
                    <template #[`item.nome`]="{ item }">
                      <div class="d-flex align-center py-2">
                        <v-icon small color="grey darken-1" class="mr-2">
                          mdi-account-outline
                        </v-icon>
                        <span class="font-weight-medium">{{ item.nome || "-" }}</span>
                      </div>
                    </template>
                    <template #[`item.empresa`]="{ item }">
                      {{ item.empresa || "-" }}
                    </template>
                    <template #[`item.cpf`]="{ item }">
                      <span class="cpf-mascarado">{{ item.cpf || "-" }}</span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </base-material-card>
    </v-container>
  </v-app>
</template>

<script>
import funerariaService from "@/services/funeraria";

export default {
  name: "RelatorioFunerario",

  components: {},

  data() {
    const hoje = new Date();
    const inicioMesAnterior = new Date(
      hoje.getFullYear(),
      hoje.getMonth() - 1,
      1,
    );
    const fimMesAnterior = new Date(hoje.getFullYear(), hoje.getMonth(), 0);

    return {
      loading: false,
      snackbar: {
        show: false,
        color: "error",
        message: "",
      },
      filtros: {
        tipoData: "Solicitação do Serviço",
        dataInicio: this.formatarDataInput(inicioMesAnterior),
        dataFim: this.formatarDataInput(fimMesAnterior),
      },
      relatorio: null,
      filtroProcedimento: "Todos",
      filtroBusca: "",
      paginaServicos: 1,
      itensPorPagina: 10,
      buscaComissao: "",
      paginaComissao: 1,
      itensPorPaginaComissao: 10,
      periodoRapido: "mesAnterior",
      tabAtiva: 0,
      loadingAgentesFunerarios: false,
      buscaAgentesFunerarios: "",
      agentesFunerarios: [],
      headersAgentesFunerarios: [
        { text: "Nome", value: "nome" },
        { text: "Empresa", value: "empresa" },
        { text: "CPF", value: "cpf" },
      ],
      periodosRapidos: [
        {
          texto: "Mês anterior",
          valor: "mesAnterior",
          icone: "mdi-calendar-month-outline",
        },
        {
          texto: "Semana anterior",
          valor: "semanaAnterior",
          icone: "mdi-calendar-week-outline",
        },
        {
          texto: "Dia anterior",
          valor: "diaAnterior",
          icone: "mdi-calendar-minus",
        },
        { texto: "Mês atual", valor: "mesAtual", icone: "mdi-calendar-month" },
        {
          texto: "Semana atual",
          valor: "semanaAtual",
          icone: "mdi-calendar-week",
        },
        { texto: "Dia atual", valor: "diaAtual", icone: "mdi-calendar-today" },
      ],
    };
  },

  computed: {
    semDados() {
      return this.totalServicos === 0;
    },

    totalServicos() {
      return Number(this.relatorio?.totalServicos || 0);
    },

    totalProcedimentosEsperados() {
      if (this.relatorio?.totalProcedimentosEsperados !== undefined) {
        return Number(this.relatorio.totalProcedimentosEsperados || 0);
      }
      return this.procedimentosResumo.reduce(
        (total, item) => total + Number(item.totalEsperado || 0),
        0,
      );
    },

    totalProcedimentosNaoRealizados() {
      if (this.relatorio?.totalProcedimentosNaoRealizados !== undefined) {
        return Number(this.relatorio.totalProcedimentosNaoRealizados || 0);
      }
      return this.procedimentosResumo.reduce(
        (total, item) => total + Number(item.quantidade || 0),
        0,
      );
    },

    totalProcedimentosRealizados() {
      if (this.relatorio?.totalProcedimentosRealizados !== undefined) {
        return Number(this.relatorio.totalProcedimentosRealizados || 0);
      }
      return Math.max(
        this.totalProcedimentosEsperados - this.totalProcedimentosNaoRealizados,
        0,
      );
    },

    percentualProcedimentosNaoRealizados() {
      if (this.relatorio?.percentualProcedimentosNaoRealizados !== undefined) {
        return Number(this.relatorio.percentualProcedimentosNaoRealizados || 0);
      }
      if (!this.totalProcedimentosEsperados) {
        return 0;
      }
      return (
        (this.totalProcedimentosNaoRealizados * 100) /
        this.totalProcedimentosEsperados
      );
    },

    procedimentosNaoRegistrados() {
      return (
        this.relatorio?.procedimentosNaoRegistrados || {
          itens: [],
        }
      );
    },

    procedimentosResumo() {
      return this.procedimentosNaoRegistrados.itens || [];
    },

    servicos() {
      return this.relatorio?.servicos || [];
    },

    servicosFiltrados() {
      const busca = this.normalizarBusca(this.filtroBusca);
      return this.servicos.filter((servico) => {
        const procedimentoOk =
          this.filtroProcedimento === "Todos" ||
          (servico.procedimentosAusentes || []).includes(
            this.filtroProcedimento,
          );
        if (!procedimentoOk) return false;
        if (!busca) return true;

        return [
          servico.cliente,
          servico.falecido,
          servico.idAtendimento,
          servico.servicoId,
          servico.protocolo,
        ].some((valor) => this.normalizarBusca(valor).includes(busca));
      });
    },

    totalPaginasServicos() {
      return Math.max(
        Math.ceil(this.servicosFiltrados.length / this.itensPorPagina),
        1,
      );
    },

    servicosPaginados() {
      const inicio = (this.paginaServicos - 1) * this.itensPorPagina;
      return this.servicosFiltrados.slice(inicio, inicio + this.itensPorPagina);
    },

    primeiroServicoPagina() {
      if (!this.servicosFiltrados.length) return 0;
      return (this.paginaServicos - 1) * this.itensPorPagina + 1;
    },

    ultimoServicoPagina() {
      return Math.min(
        this.paginaServicos * this.itensPorPagina,
        this.servicosFiltrados.length,
      );
    },

    cardsPrincipais() {
      return [
        {
          titulo: "Total de Serviços",
          valor: this.numero(this.relatorio?.totalServicos),
          subtexto: "Serviços únicos no período selecionado",
          descricao:
            "Conta cada serviço funerário uma única vez, usando a data do serviço dentro do período informado.",
          icone: "mdi-coffin",
          cor: "blue darken-2",
        },
        {
          titulo: "Procedimentos Esperados",
          valor: this.numero(this.totalProcedimentosEsperados),
          subtexto: "Procedimentos realizados e previstos",
          descricao:
            "Soma as etapas operacionais esperadas para os serviços do período, considerando etapas já registradas e etapas previstas até a etapa atual.",
          icone: "mdi-clipboard-check-outline",
          cor: "teal darken-2",
        },
        {
          titulo: "Procedimentos Realizados",
          valor: this.numero(this.totalProcedimentosRealizados),
          subtexto: "Procedimentos registradas no fluxo",
          descricao:
            "Conta as etapas esperadas que possuem registro realizado no fluxo funerário. Etapas suporte não entram no cálculo.",
          icone: "mdi-check-decagram-outline",
          cor: "indigo darken-1",
        },
        {
          titulo: "Total de Horas Trabalhadas",
          valor: this.formatarMinutos(this.relatorio?.totalMinutosTrabalhados),
          subtexto: "Soma da duração das atividades",
          descricao:
            "Calculado a partir do tempo registrado nas atividades/procedimentos realizados no período.",
          icone: "mdi-clock-time-four-outline",
          cor: "deep-orange darken-2",
        },
        {
          titulo: "Cumprimento do SLA",
          valor: this.percentualFormatado(
            this.relatorio?.sla?.percentualCumprimento,
          ),
          subtexto: `${this.numero(
            this.relatorio?.sla?.totalDentroSla,
          )} de ${this.numero(this.relatorio?.sla?.totalAvaliado)} procedimento(s)`,
          descricao:
            "Percentual de etapas avaliadas que ficaram dentro do SLA cadastrado para cada etapa.",
          icone: "mdi-timer-check-outline",
          cor: "green darken-2",
        },
        {
          titulo: "Procedimentos Não Realizados",
          valor: this.percentualFormatado(
            this.percentualProcedimentosNaoRealizados,
          ),
          subtexto: `${this.numero(
            this.totalProcedimentosNaoRealizados,
          )} de ${this.numero(
            this.totalProcedimentosEsperados,
          )} procedimento(s) esperado(s)`,
          descricao:
            "Percentual de etapas operacionais esperadas que ainda não possuem registro realizado no fluxo funerário.",
          icone: "mdi-clipboard-alert-outline",
          cor: "amber darken-3",
        },
      ];
    },

    cardsComissao() {
      const receitaTotal = Number(this.relatorio?.receitaTotal || 0);
      const valorPorProcedimento = Number(
        this.relatorio?.valorPorProcedimento || 0,
      );
      
      const totalComissao = this.colaboradoresResumo.reduce(
        (total, colaborador) => total + Number(colaborador.valorReceita || 0),
        0
      );
      
      const totalSomato = this.colaboradoresResumo.reduce(
        (total, colaborador) => total + Number(colaborador.valorSomato || 0),
        0
      );
      
      const quantidadeColaboradoresComComissao = this.colaboradoresResumo.filter(
        colaborador => Number(colaborador.valorReceita || 0) > 0
      ).length;
      
      const quantidadeSomato = this.colaboradoresResumo.reduce(
        (total, colaborador) => total + Number(colaborador.quantidadeSomato || 0),
        0
      );
      
      const diferencaReceitaComissao = receitaTotal - totalComissao;
      
      const subtextoComissao = quantidadeColaboradoresComComissao > 0
        ? `${this.numero(quantidadeColaboradoresComComissao)} colaborador${quantidadeColaboradoresComComissao !== 1 ? 'es' : ''} • R$ ${this.formatarMoeda(diferencaReceitaComissao)} não distribuído${diferencaReceitaComissao !== 1 ? 's' : ''}`
        : 'Nenhum colaborador com comissão';
      
      const subtextoSomato = quantidadeSomato > 0
        ? `${this.numero(quantidadeSomato)} ${quantidadeSomato !== 1 ? 'somatos realizados' : 'somato realizado'}`
        : 'Nenhum registro de somato';

      return [
        {
          titulo: 'Receita Total',
          valor: `R$ ${this.formatarMoeda(receitaTotal)}`,
          subtexto: `Valor por procedimento: R$ ${this.formatarMoeda(valorPorProcedimento)}`,
          icone: 'mdi-currency-usd',
          cor: 'green darken-2',
        },
        {
          titulo: 'Total de Comissão',
          valor: `R$ ${this.formatarMoeda(totalComissao)}`,
          subtexto: subtextoComissao,
          icone: 'mdi-cash-multiple',
          cor: 'blue darken-2',
        },
        {
          titulo: 'Total de Somato',
          valor: `R$ ${this.formatarMoeda(totalSomato)}`,
          subtexto: subtextoSomato,
          icone: 'mdi-cash-check',
          cor: 'purple darken-2',
        },
      ];
    },

    colaboradoresResumo() {
      const colaboradoresMap = new Map();

      this.servicos.forEach((servico) => {
        if (servico.etapas && Array.isArray(servico.etapas)) {
          servico.etapas.forEach((etapa) => {
            if (etapa.colaboradores && Array.isArray(etapa.colaboradores)) {
              etapa.colaboradores.forEach((colaborador) => {
                const id = colaborador.colaboradorId;
                const nome = colaborador.colaboradorNome;
                const quantidade = Number(colaborador.quantidade || 0);
                const receita = Number(colaborador.valorReceita || 0);

                if (colaboradoresMap.has(id)) {
                  const existing = colaboradoresMap.get(id);
                  existing.quantidade += quantidade;
                  existing.valorReceita += receita;
                } else {
                  colaboradoresMap.set(id, {
                    colaboradorId: id,
                    colaboradorNome: nome,
                    quantidade: quantidade,
                    valorReceita: receita,
                    quantidadeSomato: 0,
                    valorSomato: 0,
                  });
                }
              });
            }
          });
        }
      });

      (this.relatorio?.somato || []).forEach((colaborador) => {
        const id = colaborador.colaboradorId;
        const nome = colaborador.colaboradorNome;
        const quantidade = Number(colaborador.quantidade || 0);
        const valorSomato = Number(colaborador.valorReceita || 0);

        if (colaboradoresMap.has(id)) {
          const existing = colaboradoresMap.get(id);
          existing.quantidadeSomato += quantidade;
          existing.valorSomato += valorSomato;
        } else {
          colaboradoresMap.set(id, {
            colaboradorId: id,
            colaboradorNome: nome,
            quantidade: 0,
            valorReceita: 0,
            quantidadeSomato: quantidade,
            valorSomato,
          });
        }
      });

      return Array.from(colaboradoresMap.values())
        .map((colaborador) => ({
          ...colaborador,
          valorTotal: Number(colaborador.valorReceita || 0) + Number(colaborador.valorSomato || 0),
        }))
        .sort((a, b) => b.valorTotal - a.valorTotal);
    },

    colaboradoresResumoFiltrados() {
      const busca = this.normalizarBusca(this.buscaComissao);
      if (!busca) {
        return this.colaboradoresResumo;
      }

      return this.colaboradoresResumo.filter((colaborador) =>
        this.normalizarBusca(colaborador.colaboradorNome).includes(busca),
      );
    },

    totalPaginasComissao() {
      return Math.max(
        Math.ceil(
          this.colaboradoresResumoFiltrados.length /
            this.itensPorPaginaComissao,
        ),
        1,
      );
    },

    colaboradoresComissaoPaginados() {
      const inicio = (this.paginaComissao - 1) * this.itensPorPaginaComissao;
      return this.colaboradoresResumoFiltrados.slice(
        inicio,
        inicio + this.itensPorPaginaComissao,
      );
    },

    primeiroColaboradorComissaoPagina() {
      if (!this.colaboradoresResumoFiltrados.length) return 0;
      return (this.paginaComissao - 1) * this.itensPorPaginaComissao + 1;
    },

    ultimoColaboradorComissaoPagina() {
      return Math.min(
        this.paginaComissao * this.itensPorPaginaComissao,
        this.colaboradoresResumoFiltrados.length,
      );
    },
  },

  watch: {
    filtroBusca() {
      this.paginaServicos = 1;
    },

    filtroProcedimento() {
      this.paginaServicos = 1;
    },

    itensPorPagina() {
      this.paginaServicos = 1;
    },

    buscaComissao() {
      this.paginaComissao = 1;
    },

    itensPorPaginaComissao() {
      this.paginaComissao = 1;
    },

    totalPaginasComissao(total) {
      if (this.paginaComissao > total) {
        this.paginaComissao = total;
      }
    },

    totalPaginasServicos(total) {
      if (this.paginaServicos > total) {
        this.paginaServicos = total;
      }
    },
  },

  mounted() {
    this.carregarRelatorio();
    this.carregarAgentesFunerarios();
  },

  methods: {
    async carregarAgentesFunerarios() {
      this.loadingAgentesFunerarios = true;
      try {
        const response = await funerariaService.relatorio_funerario_agentes();
        this.agentesFunerarios = (response.data || []).sort((a, b) =>
          String(a.nome || "").localeCompare(String(b.nome || ""), "pt-BR"),
        );
      } catch (error) {
        console.error("Erro ao carregar agentes funerários:", error);
        this.exibirErro("Erro ao carregar agentes funerários.");
        this.agentesFunerarios = [];
      } finally {
        this.loadingAgentesFunerarios = false;
      }
    },

    async carregarRelatorio() {
      if (!this.filtros.dataInicio || !this.filtros.dataFim) {
        this.exibirErro("Informe a data inicial e a data final.");
        return;
      }

      if (this.filtros.dataInicio > this.filtros.dataFim) {
        this.exibirErro("A data inicial não pode ser maior que a data final.");
        return;
      }

      this.loading = true;
      try {
        const response = await funerariaService.relatorio_funerario({
          dataInicio: this.filtros.dataInicio,
          dataFim: this.filtros.dataFim,
        });
        this.relatorio = response.data || {};
        this.filtroProcedimento = "Todos";
        this.filtroBusca = "";
        this.paginaServicos = 1;
      } catch (error) {
        console.error("Erro ao carregar relatório funerário:", error);
        this.exibirErro("Erro ao carregar relatório funerário.");
        this.relatorio = null;
      } finally {
        this.loading = false;
      }
    },

    filtrarDetalhes(procedimento) {
      this.filtroProcedimento = procedimento;
    },

    aplicarPeriodoRapido(tipo) {
      const hoje = new Date();
      let inicio;
      let fim;

      if (tipo === "diaAtual") {
        inicio = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
        fim = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
      } else if (tipo === "diaAnterior") {
        const ontem = new Date(
          hoje.getFullYear(),
          hoje.getMonth(),
          hoje.getDate() - 1,
        );
        inicio = new Date(
          ontem.getFullYear(),
          ontem.getMonth(),
          ontem.getDate(),
        );
        fim = new Date(ontem.getFullYear(), ontem.getMonth(), ontem.getDate());
      } else if (tipo === "semanaAtual") {
        const diaSemana = hoje.getDay();
        const diasDesdeSegunda = diaSemana === 0 ? 6 : diaSemana - 1;
        inicio = new Date(
          hoje.getFullYear(),
          hoje.getMonth(),
          hoje.getDate() - diasDesdeSegunda,
        );
        fim = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
      } else if (tipo === "semanaAnterior") {
        const diaSemana = hoje.getDay();
        const diasDesdeSegunda = diaSemana === 0 ? 6 : diaSemana - 1;
        fim = new Date(
          hoje.getFullYear(),
          hoje.getMonth(),
          hoje.getDate() - diasDesdeSegunda - 1,
        );
        inicio = new Date(fim.getFullYear(), fim.getMonth(), fim.getDate() - 6);
      } else if (tipo === "mesAtual") {
        inicio = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
        fim = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
      } else if (tipo === "mesAnterior") {
        inicio = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1);
        fim = new Date(hoje.getFullYear(), hoje.getMonth(), 0);
      } else {
        inicio = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1);
        fim = new Date(hoje.getFullYear(), hoje.getMonth(), 0);
      }

      this.periodoRapido = tipo;
      this.filtros.dataInicio = this.formatarDataInput(inicio);
      this.filtros.dataFim = this.formatarDataInput(fim);
      this.carregarRelatorio();
    },

    numero(valor) {
      return Number(valor || 0).toLocaleString("pt-BR");
    },

    normalizarBusca(valor) {
      return String(valor || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim();
    },

    percentualFormatado(valor) {
      return `${Number(valor || 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      })}%`;
    },

    formatarMinutos(minutos) {
      const total = Number(minutos || 0);
      const horas = Math.floor(total / 60);
      const mins = total % 60;
      return `${horas}h ${mins.toString().padStart(2, "0")}min`;
    },

    formatarMoeda(valor) {
      return Number(valor || 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    totalRealizadoProcedimento(item) {
      return Math.max(
        Number((item && item.totalEsperado) || 0) -
          Number((item && item.quantidade) || 0),
        0,
      );
    },

    formatarSlaEsperado(etapa) {
      return etapa.sla ? `${etapa.sla}min` : "sem SLA";
    },

    formatarSlaRealizado(etapa) {
      const tempo =
        etapa.tempoConsideradoSla !== null &&
        etapa.tempoConsideradoSla !== undefined
          ? etapa.tempoConsideradoSla
          : etapa.tempoRealizado;
      if (tempo === null || tempo === undefined) {
        return "-";
      }
      return this.formatarMinutos(tempo);
    },

    temOcorrencia(etapa) {
      return (
        Number((etapa && etapa.tempoOcorrencia) || 0) > 0 ||
        !!(etapa && etapa.ocorrenciaJustificativa)
      );
    },

    formatarDataInput(data) {
      const ano = data.getFullYear();
      const mes = String(data.getMonth() + 1).padStart(2, "0");
      const dia = String(data.getDate()).padStart(2, "0");
      return `${ano}-${mes}-${dia}`;
    },

    exibirErro(message) {
      this.snackbar = {
        show: true,
        color: "error",
        message,
      };
    },
  },
};
</script>

<style scoped>
.relatorio-funerario {
  background-color: #eee;
}

.filtro-card {
  background-color: #f7f8fa;
}

.periodo-chips,
.procedimento-chips {
  display: flex;
  flex-wrap: wrap;
}

.periodo-chips >>> .v-chip,
.procedimento-chips >>> .v-chip {
  border-color: #d0d5dd !important;
  font-weight: 600;
  max-width: none;
}

.periodo-chips >>> .v-chip:not(.primary),
.procedimento-chips >>> .v-chip:not(.primary) {
  color: #475467;
}

.procedimento-chips >>> .v-chip__content {
  max-width: none;
  overflow: visible;
  text-overflow: clip;
  white-space: nowrap;
}

.painel-card,
.filtro-card {
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.tabela-procedimentos {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
}

.resumo-table {
  border: 1px solid #edf0f2;
  border-radius: 6px;
  overflow: hidden;
}

.resumo-table >>> thead th {
  background-color: #f8fafc;
  color: #475467 !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  text-transform: uppercase;
}

.resumo-table >>> tbody tr {
  transition: background-color 0.15s ease;
}

.resumo-table >>> tbody tr:nth-child(even) {
  background-color: rgb(231, 244, 255);
}

.resumo-table >>> tbody tr:hover,
.resumo-table >>> tbody tr.active {
  background-color: #e7f1ff;
}

.procedimento-row td,
.colaborador-row td {
  border-bottom: 1px solid #f0f2f5 !important;
}

.procedimento-dot {
  background-color: #90a4ae;
  border-radius: 50%;
  display: inline-block;
  height: 8px;
  width: 8px;
}

.colaborador-row:hover {
  background-color: #e7f1ff;
}

.tabela-colaboradores,
.tabela-agentes {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
}

.agentes-table {
  border: 1px solid #edf0f2;
  border-radius: 6px;
  overflow: hidden;
}

.tabela-busca,
.agentes-busca {
  max-width: 420px;
}

.tabela-busca >>> .v-input__slot,
.agentes-busca >>> .v-input__slot {
  min-height: 36px !important;
}

.agentes-table >>> thead th {
  background-color: #f8fafc;
  color: #475467 !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  text-transform: uppercase;
}

.agentes-table >>> tbody tr:hover {
  background-color: #e7f1ff !important;
}

.agentes-table >>> tbody td {
  border-bottom: 1px solid #f0f2f5 !important;
}

.agentes-table >>> tbody tr:nth-child(even) {
  background-color: rgb(231, 244, 255);
}

.cpf-mascarado {
  color: #475467;
  font-family: monospace;
  font-size: 12px;
}

.pointer {
  cursor: pointer;
}

.servicos-card {
  background-color: #fff;
}

.servicos-toolbar {
  align-items: stretch;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.servicos-busca-row {
  width: 100%;
}

.servicos-busca {
  max-width: 520px;
  min-width: 260px;
}

.procedimento-chips {
  width: 100%;
}

.servicos-busca >>> .v-input__slot {
  min-height: 36px !important;
}

.servicos-paginacao {
  align-items: center;
  border-top: 1px solid #edf0f2;
  display: flex;
  justify-content: space-between;
  padding-top: 14px;
}

.itens-pagina {
  max-width: 86px;
}

.servicos-paginacao >>> .v-pagination__item,
.servicos-paginacao >>> .v-pagination__navigation {
  box-shadow: none;
}

.servicos-panels,
.etapas-panels,
.atividades-panels {
  background: transparent;
}

.servicos-panels >>> .v-expansion-panel.servico-panel,
.etapas-panels >>> .v-expansion-panel.etapa-panel,
.atividades-panels >>> .v-expansion-panel.atividade-panel {
  border: 1px solid rgb(224, 224, 224) !important;
  border-radius: 8px !important;
  margin-bottom: 10px;
  overflow: hidden !important;
}

.servicos-panels >>> .v-expansion-panel.servico-panel::before,
.etapas-panels >>> .v-expansion-panel.etapa-panel::before,
.atividades-panels >>> .v-expansion-panel.atividade-panel::before {
  box-shadow: none !important;
}

.servico-panel >>> .v-expansion-panel-header,
.etapa-panel >>> .v-expansion-panel-header,
.atividade-panel >>> .v-expansion-panel-header {
  min-height: 58px;
  padding: 12px 16px;
}

.servico-panel >>> .v-expansion-panel-content__wrap {
  border-top: 1px solid #f0f2f5;
  padding: 16px;
}

.etapa-panel >>> .v-expansion-panel-content__wrap,
.atividade-panel >>> .v-expansion-panel-content__wrap {
  border-top: 1px solid #f0f2f5;
  padding: 14px 16px;
}

.etapa-panel {
  background-color: #fcfcfd !important;
  margin-left: 12px;
}

.atividade-panel {
  background-color: #fff !important;
  border-color: #edf0f2;
  margin-left: 18px;
}

.info-grid {
  background-color: #f8fafc;
  border: 1px solid #edf0f2;
  border-radius: 6px;
  padding: 8px;
}

.info-grid span {
  color: #667085;
  display: block;
  font-size: 11px;
  margin-bottom: 2px;
  text-transform: uppercase;
}

.info-grid strong {
  color: #344054;
  font-size: 13px;
  font-weight: 600;
}

.servico-header,
.etapa-header,
.atividade-header {
  align-items: center;
  display: grid;
  gap: 12px;
  width: 100%;
}

.servico-header {
  grid-template-columns: 110px minmax(180px, 1fr) minmax(180px, 1fr) 140px 130px;
}

.servico-id {
  color: #1f2937;
  font-size: 15px;
  font-weight: 700;
}

.servico-header .text-body-1 {
  color: #1f2937;
}

.servico-header .font-weight-medium {
  color: #475569;
}

.etapa-header {
  grid-template-columns: minmax(220px, 1fr) 240px 120px 90px;
}

.atividade-header {
  grid-template-columns: minmax(180px, 1fr) 120px 150px;
}

.sla-resumo {
  background-color: #f8fafc;
  border: 1px solid #edf0f2;
  border-radius: 6px;
  display: grid;
  gap: 8px;
  grid-template-columns: 1fr 1fr;
  padding: 7px 10px;
}

.sla-item span {
  color: #667085;
  display: block;
  font-size: 10px;
  line-height: 1.1;
  text-transform: uppercase;
}

.sla-item strong {
  color: #344054;
  display: block;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  margin-top: 2px;
}

.ocorrencia-box {
  background-color: #fffbeb;
  border: 1px solid #fde7b7;
  border-radius: 8px;
  padding: 12px;
}

.ocorrencia-titulo {
  align-items: center;
  color: #92400e;
  display: flex;
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 8px;
}

.ocorrencia-grid {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(3, minmax(120px, 1fr));
}

.ocorrencia-grid span {
  color: #92400e;
  display: block;
  font-size: 10px;
  text-transform: uppercase;
}

.ocorrencia-grid strong {
  color: #344054;
  display: block;
  font-size: 13px;
  margin-top: 2px;
}

.ocorrencia-texto {
  border-top: 1px solid #fde7b7;
  color: #78350f;
  font-size: 12px;
  margin-top: 10px;
  padding-top: 8px;
}

@media (max-width: 720px) {
  .servicos-toolbar,
  .servico-header,
  .etapa-header,
  .atividade-header {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .servicos-busca {
    max-width: 100%;
    width: 100%;
  }

  .servicos-paginacao {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }

  .etapa-panel,
  .atividade-panel {
    margin-left: 0;
  }

  .sla-resumo {
    grid-template-columns: 1fr;
    width: 100%;
  }

  .ocorrencia-grid {
    grid-template-columns: 1fr;
  }
}

.indicador-card-wrapper {
  position: relative;
}

.indicador-info-icon {
  position: absolute;
  right: 12px;
  bottom: 12px;
  cursor: pointer;
  z-index: 2;
}

.v-tabs {
  background-color: transparent !important;
}

.v-tab {
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: normal !important;
}

.text-success {
  color: #2e7d32 !important;
}
</style>
